// Friendly empty-state block. Pure-string output so it slots into existing
// innerHTML templates. Pick `icon` from the curated set or pass a custom one.

import { icon as renderIcon, type IconName } from './icons.js';

export type EmptyIcon = 'list' | 'search' | 'warn' | 'sparkle' | 'ledger' | 'plug';

const ICON_MAP: Record<EmptyIcon, IconName> = {
  list: 'list',
  search: 'search',
  warn: 'warn',
  sparkle: 'sparkle',
  ledger: 'ledger',
  plug: 'plug',
};

export function emptyState(opts: {
  icon?: EmptyIcon;
  title: string;
  hint?: string;
  cta?: { label: string; href: string };
}): string {
  const iconHtml = renderIcon(ICON_MAP[opts.icon ?? 'list'], { size: 28, className: 'icon-dim' });
  return `<div class="empty-state">
    <div class="empty-state__icon">${iconHtml}</div>
    <div class="empty-state__title">${escapeHtml(opts.title)}</div>
    ${opts.hint ? `<div class="empty-state__hint">${escapeHtml(opts.hint)}</div>` : ''}
    ${opts.cta ? `<a class="empty-state__cta" href="${opts.cta.href}">${escapeHtml(opts.cta.label)} →</a>` : ''}
  </div>`;
}

function escapeHtml(s: string): string {
  return s.replace(/[&<>"']/g, (c) => {
    switch (c) {
      case '&': return '&amp;';
      case '<': return '&lt;';
      case '>': return '&gt;';
      case '"': return '&quot;';
      case "'": return '&#39;';
      default: return c;
    }
  });
}
